import { mapGetters } from 'vuex';

const companyBranding = {
  computed: {
    ...mapGetters('users', ['userCompanyId']),
    branding() {
      const ret = {
        useCustomBranding: false,
        logoIconImg: '',
        logoTextImg: '',
        virtualImg: '/app/img/cards/virtual-default.png',
        physicalImg: '/app/img/cards/physical-default.png',
        virtualCardTextX: 276,
        externalFeedUrl: null,
      };

      // Stoudemire Family
      if (this.userCompanyId === 'ckhvbdup5uv900879nrp0cp8k') {
        ret.useCustomBranding = true;
        ret.logoIconImg = '';
        ret.logoTextImg = '/app/img/logos/blvd-mgmt.png';
        ret.virtualImg = '/app/img/cards/virtual-amare-family.png';
        ret.physicalImg = '/app/img/cards/physical-amare-family.png';
        ret.virtualCardTextX = 8;
      }

      // Amare Stoudemire Foundation
      if (this.userCompanyId === 'ckgmgx1ixerdp0879rizuode9') {
        ret.useCustomBranding = true;
        ret.logoIconImg = '';
        ret.logoTextImg = '/app/img/logos/blvd-mgmt.png';
        ret.virtualImg = '/app/img/cards/virtual-amare.png';
        ret.physicalImg = '/app/img/cards/physical-amare.png';
        ret.virtualCardTextX = 8;
        ret.externalFeedUrl = 'https://www.hub-suite.com/aau-fundraiser-feed.json';
      }

      // Topdevz
      if (this.userCompanyId === 'ck611qfvk29ic0774vjn9r9lb') {
        ret.useCustomBranding = true;
        ret.logoIconImg = '';
        ret.logoTextImg = '/app/img/logos/topdevz.png';
        ret.virtualImg = '/app/img/cards/virtual-topdevz.png';
        ret.physicalImg = '/app/img/cards/physical-topdevz.png';
        ret.virtualCardTextX = 8;
      }

      // Appnexio
      if (this.userCompanyId === 'ck617g4ci2ahr0774azglclkl') {
        ret.useCustomBranding = true;
        ret.logoIconImg = '';
        ret.logoTextImg = '/app/img/logos/appnexio.png';
        ret.virtualImg = '/app/img/cards/virtual-appnexio.png';
        ret.physicalImg = '/app/img/cards/physical-appnexio.png';
        ret.virtualCardTextX = 8;
      }

      // Rajaee Family
      if (this.userCompanyId === 'ck6tokwmb1l310797pg75ypqf') {
        ret.useCustomBranding = true;
        ret.logoIconImg = '';
        ret.logoTextImg = '/app/img/logos/rajaee.png';
        ret.virtualImg = '/app/img/cards/virtual-rajaee.png';
        ret.physicalImg = '/app/img/cards/physical-rajaee.png';
        ret.virtualCardTextX = 8;
      }


      // Jet Access Aviation LLC
      if (this.userCompanyId === 'ckiqdmwlobp060779kfzsuuoh') {
        ret.useCustomBranding = true;
        ret.logoIconImg = '';
        ret.logoTextImg = '/app/img/logos/jet-access.png';
        ret.virtualImg = '/app/img/cards/virtual-jet-access.png';
        ret.physicalImg = '/app/img/cards/physical-jet-access.png';
        ret.virtualCardTextX = 8;
      }

      return ret;
    },
  },
};

export default companyBranding;
